/**
 * AdsterraBanner - Renders an Adsterra "highperformanceformat" banner ad.
 *
 * The invoke.js script relies on document.write, which would wipe out the
 * React app if executed directly in the main document. It's isolated inside
 * an iframe (built via a blob URL) so document.write only affects that
 * iframe's own document.
 */
import { useEffect, useRef } from 'react';

export function AdsterraBanner({ adKey, width, height, className = '' }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const html = `<!DOCTYPE html>
<html>
  <head>
    <style>html,body{margin:0;padding:0;overflow:hidden;background:transparent;}</style>
  </head>
  <body>
    <script>
      atOptions = {
        'key': '${adKey}',
        'format': 'iframe',
        'height': ${height},
        'width': ${width},
        'params': {}
      };
    </script>
    <script src="https://www.highperformanceformat.com/${adKey}/invoke.js"></script>
  </body>
</html>`;

    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    iframe.src = url;

    return () => URL.revokeObjectURL(url);
  }, [adKey, width, height]);

  return (
    <iframe
      ref={iframeRef}
      title="advertisement"
      width={width}
      height={height}
      scrolling="no"
      className={className}
      style={{ border: 'none', overflow: 'hidden', flexShrink: 0 }}
      data-testid="adsterra-banner"
    />
  );
}

export default AdsterraBanner;
